import { setFetchStartState } from '../fetchLoadable';
import { createNotLoaded } from '../Loadable/utils';
import * as actionTypes from './actionTypes';
export const workflowsReducer = (state = createNotLoaded(), action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_WORKFLOWS_START:
            return Object.assign({}, setFetchStartState(state, payload.res));
        case actionTypes.FETCH_WORKFLOWS_SUCCESS:
        case actionTypes.FETCH_WORKFLOWS_ERROR:
            return Object.assign({}, payload.res);
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map